import { Injectable } from '@angular/core';
import { RECOVERY_STORAGE_PREFIX } from '../../../core/services/recovery-storage';
import { ProfileEditor, isRecord } from '../domain/member-profile';

export interface ProfileReceipt { owner: number; kind: ProfileEditor; outcome: 'pending' | 'unknown' | 'confirmed'; }
@Injectable({ providedIn: 'root' })
export class ProfileOperationStorage {
  private key(owner: number) { return `${RECOVERY_STORAGE_PREFIX}profile:${owner}`; }
  read(owner: number): ProfileReceipt | null {
    const raw = sessionStorage.getItem(this.key(owner));
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (!isRecord(value) || value['owner'] !== owner ||
        !['email', 'loginId', 'password', 'emergency'].includes(String(value['kind'])) ||
        !['pending', 'unknown', 'confirmed'].includes(String(value['outcome']))) throw Error('Invalid operation receipt');
    return value as unknown as ProfileReceipt;
  }
  write(receipt: ProfileReceipt): void { sessionStorage.setItem(this.key(receipt.owner), JSON.stringify(receipt)); }
  clear(owner: number): void { sessionStorage.removeItem(this.key(owner)); }
}
